module.exports = __webpack_public_path__ + "img/ANGEL SHADES BW.5e5257f.svg";